import { c as _c } from "react-compiler-runtime";
import { useCallback, useState } from 'react';
import useCollaborationSidebarState from './useCollaborationSidebarState';
import { Metrics } from '../utils/metrics';
import useHasCommentingFeature from './useHasCommentingFeature';
import * as commentingApi from '../api/CommentingV3';
export default function useFetchComments() {
  "use memo";

  const $ = _c(13);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [comments, setComments] = useState(t0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const {
    onUpdateCollaborationSidebarState,
    modulesWithReplies
  } = useCollaborationSidebarState();
  const hasCommentingFeature = useHasCommentingFeature();
  let t1;
  if ($[1] !== hasCommentingFeature) {
    t1 = t2 => {
      const {
        objectType,
        objectId,
        refetch
      } = t2;
      if (!hasCommentingFeature) {
        return;
      }
      if (!objectId || !objectType) {
        return;
      }
      setLoading(true);
      commentingApi.fetchCommentsCached({
        objectType,
        objectId,
        refetch
      }).then(t3 => {
        const {
          results
        } = t3;
        setComments(results || []);
        Metrics.counter("fetch-comments-cached-success", {
          object_type: objectType
        }).increment();
      }).catch(e => {
        var _networkError;
        Metrics.counter("fetch-comments-cached-error", {
          object_type: objectType,
          status: (_networkError = e.networkError) === null || _networkError === void 0 ? void 0 : _networkError.status
        }).increment();
        setError(e);
      }).finally(() => {
        setLoading(false);
      });
    };
    $[1] = hasCommentingFeature;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const fetchComments = t1;
  let t2;
  if ($[3] !== comments || $[4] !== modulesWithReplies || $[5] !== onUpdateCollaborationSidebarState) {
    t2 = t3 => {
      const {
        objectType: objectType_0,
        objectId: objectId_0,
        updatedCommentId
      } = t3;
      const updatedComments = comments.map(comment => {
        if (comment.id === updatedCommentId) {
          return Object.assign({}, comment, {
            read: true
          });
        }
        return comment;
      });
      setComments(updatedComments);
      commentingApi.updateCommentsCache({
        objectType: objectType_0,
        objectId: objectId_0,
        updatedCommentId,
        comments: updatedComments,
        modulesWithReplies,
        onUpdateCollaborationSidebarState
      });
    };
    $[3] = comments;
    $[4] = modulesWithReplies;
    $[5] = onUpdateCollaborationSidebarState;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const updateCache = t2;
  let t3;
  if ($[7] !== comments || $[8] !== error || $[9] !== fetchComments || $[10] !== loading || $[11] !== updateCache) {
    t3 = {
      fetchComments,
      comments,
      error,
      loading,
      updateCache
    };
    $[7] = comments;
    $[8] = error;
    $[9] = fetchComments;
    $[10] = loading;
    $[11] = updateCache;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}